import { useCallback, useMemo, useState } from 'react';
import uuid from 'react-native-uuid';
import { extractFileExtension } from '../utils';
export const UPLOAD_MAX_MB = 100;
export const UPLOAD_MAX_BYTES = UPLOAD_MAX_MB * 1024 * 1024;
export const REMOVAL_TIME_MS = 5 * 1000;
const useUploadQueue = ({ upload }) => {
    const [queue, setQueue] = useState([]);
    const hasInProgress = useMemo(() => queue.some((q) => !q.isDone && !q.isError), [queue]);
    const documentsQueue = useMemo(() => queue
        .filter((q) => !q.isDone && !q.isError)
        .map((q) => ({ id: q.id, title: q.title ?? '', created_at: q.createdAt })), [queue]);
    const createRemovalTimer = useCallback((id) => {
        const timeout = setTimeout(() => {
            setQueue((prev) => prev.filter((i) => i.id !== id));
            clearTimeout(timeout);
        }, REMOVAL_TIME_MS);
    }, []);
    const addQueueItem = useCallback((item) => {
        setQueue((prev) => [...prev, item]);
        if (item.isError) {
            createRemovalTimer(item.id);
        }
    }, [createRemovalTimer]);
    const doUpload = useCallback((file) => {
        const id = uuid.v4();
        addQueueItem({
            id,
            title: file.name,
            type: extractFileExtension(file.name),
            createdAt: new Date().toISOString(),
            progress: 0,
            isDone: false,
            isError: false
        });
        // Core builds the multipart body from `data.file` and reads `data.file.name`
        // for the title; both the web `File` and the RN file object satisfy this.
        const data = {
            file: file,
            progressCallBack: (e) => {
                const progress = e.progress ?? (e.total ? e.loaded / e.total : 0);
                setQueue((prev) => prev.map((i) => (i.id === id ? { ...i, progress } : i)));
            }
        };
        upload.mutateAsync(data).then(() => setQueue((prev) => prev.filter((i) => i.id !== id)), () => {
            setQueue((prev) => prev.map((i) => (i.id === id ? { ...i, isError: true } : i)));
            createRemovalTimer(id);
        });
    }, [addQueueItem, createRemovalTimer, upload]);
    return {
        queue,
        hasInProgress,
        documentsQueue,
        queueActions: { doUpload, addQueueItem }
    };
};
export { useUploadQueue };
//# sourceMappingURL=useUploadQueue.js.map